import { render, staticRenderFns } from "./ConfigMobile.vue?vue&type=template&id=6cb41ae9&"
import script from "./ConfigMobile.vue?vue&type=script&lang=js&"
export * from "./ConfigMobile.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports